var _defs, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "more",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:#4f5969}\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_267",
    fill: "rgba(131,142,159,0)",
    d: "M0 0H20V20H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_895",
    transform: "translate(8 1.999)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_678",
    cx: 1.992,
    cy: 1.992,
    r: 1.992,
    className: "cls-2"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_679",
    cx: 1.992,
    cy: 1.992,
    r: 1.992,
    className: "cls-2",
    transform: "translate(0 6.008)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_680",
    cx: 1.992,
    cy: 1.992,
    r: 1.992,
    className: "cls-2",
    transform: "translate(0 12.017)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMore);
export default __webpack_public_path__ + "static/media/more.565ac4406924ca34d4c98923c21c5832.svg";
export { ForwardRef as ReactComponent };